export function isScreenShareTrack(track?: MediaStreamTrack | null): boolean {
  if (!track || track.kind !== 'video') return false;

  // Kamera track'leri 'motion', ekran paylaşımı 'detail' olarak işaretlenir (useMediaStream).
  if (track.contentHint === 'detail') return true;
  if (track.contentHint === 'motion') return false;

  return /screen|window|display|monitor|tab|capture|desktop|entire/i.test(track.label);
}

export function getParticipantScreenShareState(stream?: MediaStream | null, flagged = false): boolean {
  if (flagged) return true;
  const videoTrack = stream?.getVideoTracks()[0];
  return isScreenShareTrack(videoTrack);
}

export function attachStreamToVideo(
  video: HTMLVideoElement | null,
  stream: MediaStream | null | undefined
) {
  if (!video || !stream) return;
  if (video.srcObject !== stream) {
    video.srcObject = stream;
  }
  video.play().catch(() => {});
}
